var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "DatetimePicker",
    _vm._g(
      _vm._b(
        {
          attrs: {
            clearable: false,
            "first-day-of-week": _vm.firstDay,
            format: _vm.format,
            lang: _vm.lang,
            "minute-step": 5,
            "show-second": false,
            type: "time",
            use12h: _vm.showAmPm,
            value: _vm.date
          },
          on: { change: _vm.change }
        },
        "DatetimePicker",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }